import { render } from "./FormTextArea.vue?vue&type=template&id=88fe86bc&scoped=true"
import script from "./FormTextArea.vue?vue&type=script&lang=js"
export * from "./FormTextArea.vue?vue&type=script&lang=js"

import "./FormTextArea.vue?vue&type=style&index=0&id=88fe86bc&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88fe86bc"]])

export default __exports__